module.exports = __webpack_public_path__ + "img/banner3_2_kr.ca15e0f1.png";